import deephowApiServerWrapper from "@/server/api-server";

export const createSop = (payload) => deephowApiServerWrapper("post", "/v1/multimodal-sop/", payload);

export const deleteSop = (id) => deephowApiServerWrapper("delete", `/v1/multimodal-sop/${id}`);

export const updateSop = (id, payload) => deephowApiServerWrapper("patch", `/v1/multimodal-sop/${id}`, payload);
